import { render } from "./Dable.vue?vue&type=template&id=61b2d9f1&scoped=true"
import script from "./Dable.vue?vue&type=script&lang=js"
export * from "./Dable.vue?vue&type=script&lang=js"

import "./Dable.vue?vue&type=style&index=0&id=61b2d9f1&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b2d9f1"]])

export default __exports__